import React, { useEffect, useState } from "react";
import Table, { AvatarCell, SelectColumnFilter, StatusPill, ImageCell,ProductCell  } from "./Table"; // new

function TableData() {
  const data = [
    {
      product: "2 X 4M Stagging",
      customer: "Dutch Grown",
      id: "#1345cdvbd",
      quantity: "102",
    },
    {
      product: "Electric Foot",
      customer: "Cambo",
      id: "#23232cbedf",
      quantity: "102",
    },
    {
      product: "5 axis CNC",
      customer: "Avon Bulbs",
      id: "#334434erer",
      quantity: "102",
    },
    {
      product: "Massage Chair",
      customer: "Broardleight Bulbs",
      id: "#43454fcedfd",
      quantity: "102",
    },
  ];

  const columns = React.useMemo(
    () => [
      {
        Header: "Product",
        accessor: "product",
        Cell: ProductCell,
      },
      {
        Header: "Customer",
        accessor: "customer",
      },
      {
        Header: "Tracking ID",
        accessor: "id",
      },
      {
        Header: "QTY",
        accessor: "quantity",
      },
      {
        Header: "Date",
        accessor: "date",
        Cell: (value) => (
          <div className="flex flex-wrap">
            <div className=" text-gray-900 py-4 font-medium ">
             {" "}
             <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
             <path d="M14.1667 14.1667H11.3333V11.3333H14.1667V14.1667ZM9.91667 7.08333H7.08333V9.91667H9.91667V7.08333ZM14.1667 7.08333H11.3333V9.91667H14.1667V7.08333ZM5.66667 11.3333H2.83333V14.1667H5.66667V11.3333ZM9.91667 11.3333H7.08333V14.1667H9.91667V11.3333ZM5.66667 7.08333H2.83333V9.91667H5.66667V7.08333ZM17 1.41667V17H0V1.41667H2.125V2.125C2.125 2.90629 2.76037 3.54167 3.54167 3.54167C4.32296 3.54167 4.95833 2.90629 4.95833 2.125V1.41667H12.0417V2.125C12.0417 2.90629 12.677 3.54167 13.4583 3.54167C14.2396 3.54167 14.875 2.90629 14.875 2.125V1.41667H17ZM15.5833 5.66667H1.41667V15.5833H15.5833V5.66667ZM14.1667 0.708333C14.1667 0.317333 13.85 0 13.4583 0C13.0666 0 12.75 0.317333 12.75 0.708333V2.125C12.75 2.516 13.0666 2.83333 13.4583 2.83333C13.85 2.83333 14.1667 2.516 14.1667 2.125V0.708333ZM4.25 2.125C4.25 2.516 3.93337 2.83333 3.54167 2.83333C3.14996 2.83333 2.83333 2.516 2.83333 2.125V0.708333C2.83333 0.317333 3.14996 0 3.54167 0C3.93337 0 4.25 0.317333 4.25 0.708333V2.125Z" fill="black" fill-opacity="0.7"/>
             </svg>
            </div>
            <div className="mt-3 ml-2 text-gray-400 font-medium">
            21-oct-2021
            </div>
          </div>
        ),
      },
    
    ],
    []
  );

  return (
    <div className="mb-8 pb-4">
      <main className="max-w-full min-h-full px-4 sm:px-6 lg:px-8 pt-4">
        <div className="-mt-10">
          <Table
            columns={columns}
            data={data == undefined ? [] : data}
            text="Undefined"
          />
        </div>
      </main>
    </div>
  );
}

export default TableData;
